import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setArticle, clearArticlesErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  articles: PropTypes.object,
  error: PropTypes.any,
};

class ArticlesNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        title: '',
        slug: '',
        contents: '',
      },
      article: {
        altText: '',
        contents: '',
        image: '',
        slug: '',
        summary: '',
        thumbnail: '',
        title: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.article && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Article saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { required, article } = this.state
    Object.keys(required).forEach((paramName) => {
      const param = article[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const nextState = this.state.article;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      articles: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearArticlesErrors());
    const pArticle = this.state.article;
    pArticle.tagline = (pArticle.tagline === null) ? '' : pArticle.tagline;
    this.props.dispatch(setArticle(pArticle));
  }
  handleCancel() {
    this.props.dispatch(clearArticlesErrors());
    browserHistory.push('/articles?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/articles?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      inputStyleMid: {
        marginRight: '2%',
        width: '100%',
        maxWidth: '500px'
      },
      inputStyleLong: {
        marginRight: '2%',
        width: '100%',
      },
    };
    return (
      <div className="category component" style={authPage}>
        <h2>New Article</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div>
            <TextField
              floatingLabelText="Title"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.article.title}
              name="title"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.title}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Slug"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.article.slug}
              name="slug"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={this.state.required.slug}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Contents"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.article.contents}
              name="contents"
              onChange={this.handleChange}
              style={styles.inputStyleMid}
              errorText={this.state.required.contents}
              errorStyle={{ color: cyan500 }}
              multiLine={true}
            />
            <TextField
              floatingLabelText="Summary"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.article.summary}
              name="summary"
              onChange={this.handleChange}
              style={styles.inputStyleMid}
              multiLine={true}
            />
            <TextField
              floatingLabelText="Image Url"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.article.image}
              name="image"
              onChange={this.handleChange}
              style={styles.inputStyleLong}
            />
            <TextField
              floatingLabelText="Thumbnail"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.article.thumbnail}
              name="thumbnail"
              onChange={this.handleChange}
              style={styles.inputStyleLong}
            />
            <TextField
              floatingLabelText="Alt Text"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.article.altText}
              name="altText"
              onChange={this.handleChange}
              style={styles.inputStyle}
            />
          </div>
        </div>
      </div>
    );
  }
}
 ArticlesNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};
 ArticlesNewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    error: state.articles.error,
  };
}

export default withRouter(connect(mapStateToProps)(ArticlesNewPage))



// WEBPACK FOOTER //
// ./src/containers/ArticlesNewPage.js